<template>
  <w-stack
    align-items="center"
    justify-content="center"
    full-width
    full-height
    class="nav__item"
    :class="{ 'nav__item--active': isActive }"
  >
    <w-link
      class="nav__link"
      :class="{ 'nav__link--active': isActive }"
      @click="handleClick"
    >
      <w-icon
        :name="icon"
        size="large"
        :color="color"
      />
    </w-link>
  </w-stack>
</template>

<script setup lang="ts">
import { WIcon, WLink, WStack } from '@dp-watson-web/components';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps<{
  icon: string;
  route: {
    name: string;
    params?: Record<string, string>;
  };
}>();

const currentRoute = useRoute();
const router = useRouter();

const isActive = computed(() => {
  return currentRoute.matched.some((matchedRoute) => matchedRoute.name === props.route.name);
});

const color = computed(() => {
  return isActive.value ? 'inverted' : 'muted';
});

const handleClick = () => {
  router.push(props.route);
};
</script>

<style lang="scss" scoped>
.nav {
  &__item {
    height: 48px;
    width: 48px;
    border-radius: var(--w-border-radius-s);

    &--active {
      background-color: var(--w-color-background-accent-inverted);
    }

    &:hover:not(.nav__item--active) {
      background-color: var(--w-color-background-hover);
    }
  }

  &__link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    &:hover:not(.nav__link--active) {
      .w-icon {
        fill: var(--w-color-foreground-secondary);
      }
    }
  }
}
</style>
